const Categories = ({
  categories = [],
  selectedCategory,
  onCategorySelect,
}) => {
  return (
    <div className="bg-gray-100 rounded-2xl my-4 p-3">
      <h3 className="text-xl font-black text-blue-950 mb-2">Categorias</h3>
      <ul className="space-y-2 divide-y">
        {/* Opção para "Todas" */}
        <li
          className={`cursor-pointer ${
            selectedCategory === ""
              ? "text-blue-600 font-bold"
              : "text-gray-800"
          }`}
          onClick={() => onCategorySelect("")}
        >
          Todas
        </li>
        {/* Renderiza cada categoria */}
        {categories.map((category) => (
          <li
            key={category}
            className={`cursor-pointer ${
              selectedCategory === category
                ? "text-blue-600 font-bold"
                : "text-gray-800"
            }`}
            onClick={() => onCategorySelect(category)}
          >
            {category}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Categories;
